<script setup>
import {
    defineProps, defineEmits, onMounted, ref,
    // watch, 
    // computed 
} from 'vue';
import i18n from "@/i18n"
const props = defineProps({
    title: {
        type: String,
        required: true,
        default: '数字护照：质量'
    },
    // 第一层数据
    databaseList: {
        type: Array,
        required: true,
        default: () => []
    },
    // hscodeList: {
    //     type: Array,
    //     required: true,
    //     default: () => []
    // },
    placeholder: {
        type: String,
        required: true,
        default: ''
    },
    showInput1: {
        type: Boolean,
        required: true,
        default: true
    }
})

const emits = defineEmits(['search',])
// const selectedIndex = ref(0)
const hscodeList = ref([])
const hscode = ref('')
const keyword = ref('')
// const hscodeListStr = computed(() => JSON.stringify(props.databaseList))
// const selectedHscodeList = ref()
const type = ref([])
// 获取所选 hscode 
// const getSelectedHscodeList = () => {
//     // selectedHscodeList.value = props.hscodeList[selectedIndex.value].children
// }

const search = () => {
    //搜索
    emits('search', { hscode: hscode.value, keyword: keyword.value.trim(), product_template_name: type.value, })
}
// const changeTemplate1 = () => {
//     // console.log(props.databaseList);
//     // console.log(type.value);
//     hscode.value = ''
//     if (type.value) {
//         let arr = props.databaseList.filter(item => item.name === type.value)
//         hscodeList.value = arr[0].list.map(item => {
//             return {
//                 id: item.hscode.id,
//                 title: item.hscode.title,
//             }
//         })
//     } else {
//         hscodeList.value = []
//     }
// }
const changeTemplate = () => {
    hscode.value = ''
    if (type.value.length) {
        // console.log(type.value);
        let arr = props.databaseList.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}


onMounted(() => {
})

// watch(hscodeListStr, () => {
//     getSelectedHscodeList();
// }, { deep: true })

// watch(selectedIndex, () => {
//     getSelectedHscodeList();
// })
</script>
<template>
    <div class="card card1 px-3" style="border-radius: 0.55rem; height: 22%; ">
        <div class="my-card-header my-2">{{ props.title }}</div>
        <div class="my-card-content py-2"
            style="height: calc(100% - 24px - 1rem);display: flex; flex-direction: column; justify-content: space-between;">
            <div class="hscode ">
                <!-- <span v-for="(item, key) in props.hscodeTopList" :key="key" class="cursor-pointer"
                    @click="selectedIndex = key">
                    <span :class="selectedIndex == key && 'active'">{{ item }}</span>
                    <span class="mx-2" v-if="key < props.hscodeTopList.length - 1">|</span>
                </span> -->
                <!-- <el-select @change="changeTemplate" v-model="type" filterable clearable
                    :placeholder="$t('dashboard.dataBaseType')" style="width: 100%; height: 38px;">
                    <el-option v-for="item in props.databaseList" :key="item.id" :label="item.name"
                        :value="item.name" />
                </el-select> -->
                <el-cascader style="width: 100%; height: 38px;" v-model="type" :options="props.databaseList"
                    :placeholder="$t('dashboard.dataBaseType')"
                    :props="{ label: i18n.global.locale == 'en' ? 'label_en' : 'label', }" @change="changeTemplate" />
            </div>
            <!-- 搜索框 -->
            <div class="search  d-flex">
                <!-- <el-cascader placeholder="HS Code" style="width: 110px; height: 38px;"
                    :props="{ label: 'title', value: 'id' }" :show-all-levels="false" v-model="hscode"
                    :options="hscodeList" filterable clearable class="me-2" /> -->
                <el-select v-model="hscode" filterable clearable placeholder="HS Code"
                    style="min-width: 111px; height: 38px;">
                    <el-option v-for="item in hscodeList" :key="item.value"
                        :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                </el-select>
                <input v-show="props.showInput1" clearable class="form-control ms-2" v-model="keyword" required
                    :placeholder="placeholder" />
            </div>

            <div style="text-align: center;">
                <button type="button" class="btn btn-success" @click="search()" style="min-width: 93px;">
                    {{ $t("base.search") }}
                </button>
            </div>
        </div>
    </div>

</template>
<style scoped lang="scss">
// .card {
//     background-color: #495057;
//     border: 1px solid #D9D9D980;

//     .my-card-header {
//         color: white;
//         font-size: 0.7vw;
//         font-weight: 700;
//     }

//     .my-card-content {
//         .hscode {

//             // color: #9599AD;
//             // word-break: break-all;
//             // .active {
//             //     color: white !important;
//             // }
//             :deep(.el-select__wrapper) {
//                 background-color: #4a5056;
//                 height: 100%;
//             }

//             :deep(.el-input__wrapper) {
//                 background-color: #4a5056;
//             }

//             :deep(.el-select__placeholder.is-transparent) {
//                 color: #889AA5 !important;
//             }

//             :deep(.el-select__selected-item) {
//                 color: white;
//             }
//         }

//         .search {
//             height: 38px;

//             :deep(.el-select__wrapper) {
//                 background-color: #4a5056;
//                 height: 100%;
//             }

//             :deep(.el-select__placeholder.is-transparent) {
//                 color: #889AA5 !important;
//             }

//             :deep(.el-select__selected-item) {
//                 color: white;
//             }

//             :deep(.el-input--suffix) {
//                 width: 110px;
//                 height: 100%;
//             }

//             :deep(.el-input__wrapper) {
//                 background-color: #4a5056;
//             }

//             :deep(.el-input__inner) {
//                 color: white;
//             }

//             .form-control {
//                 background-color: #4a5056;
//                 color: white;
//             }
//         }
//     }
// }
.card1 {
    // background-color: #495057;
    border: 1px solid #D9D9D980;

    .my-card-header {
        color: #212529;
        font-size: 16px;
        font-weight: 700;
    }

    .my-card-content {
        .hscode {

            // color: #9599AD;
            // word-break: break-all;
            // .active {
            //     color: white !important;
            // }
            :deep(.el-select__wrapper) {
                // background-color: #4a5056;
                height: 100%;
            }

            // :deep(.el-input__wrapper) {
            //     // background-color: #4a5056;
            // }

            :deep(.el-select__placeholder.is-transparent) {
                font-size: 0.8125rem;
                color: #878a99 !important;
            }

            :deep(.el-select__selected-item) {
                font-size: 0.8125rem;
                color: #212529;
            }

            :deep(.el-input--suffix) {
                width: 100%;
                height: 100%;
            }

            :deep(.el-cascader .el-input__inner) {
                &::placeholder {
                    font-size: 0.8125rem;
                    color: #878a99 !important;
                }
            }

            :deep(.el-select__selected-item.el-select__placeholder) {
                font-size: 0.8125rem;
                color: #212529;
            }

            // :deep(.el-input__wrapper) {
            //     // background-color: #4a5056;
            // }

            :deep(.el-input__inner) {
                font-size: 0.8125rem;
                color: #212529;
            }

        }

        .search {
            height: 38px;

            :deep(.el-select__wrapper) {
                // background-color: #4a5056;
                height: 100%;
            }

            :deep(.el-select__placeholder.is-transparent) {
                color: #889AA5 !important;
                font-size: 0.8125rem;
            }

            :deep(.el-select__selected-item) {
                color: #212529;
                font-size: 0.8125rem;
            }

            :deep(.el-cascader .el-input--suffix) {
                width: 100% !important;
            }

            :deep(.el-input--suffix) {
                width: 110px;
                height: 100%;
            }

            // :deep(.el-input__wrapper) {
            //     // background-color: #4a5056;
            // }

            :deep(.el-input__inner) {
                color: #212529;
            }

            .form-control {
                // background-color: #4a5056;
                color: #212529;
            }
        }
    }

    :deep(.el-select__placeholder.is-transparent) {
        font-size: 0.8125rem;
        color: #878a99 !important;
    }

    :deep(.el-select__selected-item.el-select__placeholder) {
        font-size: 0.8125rem;
        color: #212529;
    }

    :deep(.el-cascader .el-input__inner) {
        font-size: 0.8125rem;
        color: #212529;
    }

    :deep(.el-cascader .el-input__inner::placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-moz-placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-moz-placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
        color: #878a99;
    }
}
</style>